import React, { useState, useContext, useEffect } from 'react';
import SideNav from '../shared/SideNav';
import Breadcrumb from '../../shared/Breadcrumb';
import { AuthContext } from '../../../contexts/AuthContext';
import axios from 'axios';
import { apiRoutes } from '../../../AppSettings';
import Util from '../../../Util';
import { Link } from 'react-router-dom';

const DoctorDashboard = () => {
    const { userState } = useContext(AuthContext);
    const [doctor, setDoctor] = useState(userState.loggedInUser);
    const [appoinments, setAppoinments] = useState([]);
    const [todayAppoinments, setTodayAppoinments] = useState([]);
    const [upcomingAppoinments, setUpcomingAppoinments] = useState([]);
    const [counts, setCounts] = useState({ totalPatients: 0, todayPatients: 0, totalAppoinments: 0 });

    const [promiseInProgress, setPromiseInProgress] = useState({appoinmentLoaded: true, countLoaded: true});

    const loggedInDoctorId = userState.user.userId;

    const updateCounts = (data) => {
        setCounts({ totalPatients: data.totalPatients, todayPatients: data.todayPatients, totalAppoinments: data.totalAppoinments })
    }

    const updateVariables = (data) => {
        setAppoinments(data);

        setTodayAppoinments(data.filter(item => {
            return new Date(item.appoinmentDate).getDate() === (new Date()).getDate();
        }));

        setUpcomingAppoinments(data.filter(item => {
            return new Date(item.appoinmentDate) > new Date();
        }));
    }

    const options = {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'bearer ' + userState.token
        }
    };

    useEffect(() => {
        loadDashboard();
    }, []);

    const loadDashboard = () => {
        axios.get(apiRoutes.getAppoinments + loggedInDoctorId, options)
        .then((response) => {
            if (response.status === 200) {
                const data = response.data;
                //  console.log(data.data)
                updateVariables(data.data);

                setPromiseInProgress({...promiseInProgress, appoinmentLoaded: false});
            }
        }, (error) => {
            console.log(error);
        });

        axios.get(apiRoutes.getDashboardCount + loggedInDoctorId, options)
        .then((response) => {
            if (response.status === 200) {
                const data = response.data;
                updateCounts(data.data);

                setPromiseInProgress({...promiseInProgress, countLoaded: false});
            }
        }, (error) => {
            console.log(error);
        });
    } 

    return (
        <div>
            <Breadcrumb title="Dashboard" />
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                            <SideNav applyCssFor='dashboard' user={doctor} />
                        </div>
                        <div className="col-md-7 col-lg-8 col-xl-9">
                             <div className="row">
                                <div className="col-md-12">
                                    <div className="card dash-card">
                                        <div className="card-body">
                                            <div className="row dashboard-count" >
                                                <div className="col-md-12 col-lg-4">
                                                    <div className="dash-widget dct-border-rht">
                                                        <div className="circle-bar circle-bar1">
                                                            <div className="circle-graph1" data-percent="75">
                                                                <img src="assets/img/icon-01.png" className="img-fluid" alt="patient" />
                                                            </div>
                                                        </div>
                                                        <div className="dash-widget-info">
                                                            <h6>Total Patient</h6>
                                                            <h3>{counts.totalPatients}</h3>
                                                            <p className="text-muted">Till Today</p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-12 col-lg-4">
                                                    <div className="dash-widget dct-border-rht">
                                                        <div className="circle-bar circle-bar2">
                                                            <div className="circle-graph2" data-percent="65">
                                                                <img src="assets/img/icon-02.png" className="img-fluid" alt="Patient" />
                                                            </div>
                                                        </div>
                                                        <div className="dash-widget-info">
                                                            <h6>Today Patient</h6>
                                                            <h3>{counts.todayPatients}</h3>
                                                            <p className="text-muted">{Util.getFormatDate({ date: (new Date()) })}</p>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div className="col-md-12 col-lg-4">
                                                    <div className="dash-widget">
                                                        <div className="circle-bar circle-bar3">
                                                            <div className="circle-graph3" data-percent="50">
                                                                <img src="assets/img/icon-03.png" className="img-fluid" alt="Patient" />
                                                            </div>
                                                        </div>
                                                        <div className="dash-widget-info">
                                                            <h6>Appoinments</h6>
                                                            <h3>{counts.totalAppoinments}</h3>
                                                            <p className="text-muted">Till Today</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-md-12">
                                    <h4 className="mb-4">Patient Appoinment</h4>
                                    <div className="appointment-tab">

                                        <ul className="nav nav-tabs nav-tabs-solid nav-tabs-rounded">
                                            <li className="nav-item">
                                                <a className="nav-link active" href="#upcoming-appointments" data-toggle="tab">Upcoming</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link" href="#today-appointments" data-toggle="tab">Today</a>
                                            </li>
                                        </ul>

                                        <div className="tab-content">
                                            <div className="tab-pane show active" id="upcoming-appointments">
                                                <div className="card card-table mb-0">
                                                    <div className="card-body">
                                                        <div className="table-responsive">
                                                            <table className="table table-hover table-center mb-0">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Patient Name</th>
                                                                        <th>Appt Date</th>
                                                                        <th>Purpose</th>
                                                                        <th>Type</th>
                                                                        <th className="text-center">Paid Amount</th>
                                                                        <th></th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        upcomingAppoinments.map(a => (
                                                                            <tr key={a.appoinmentId}>
                                                                                <td>
                                                                                    <h2 className="table-avatar">


                                                                                        <Link className="avatar avatar-sm mr-2"
                                                                                            to={
                                                                                                {
                                                                                                    pathname: '/PatientProfile',
                                                                                                    state: {
                                                                                                        patientId: a.patient.patientId
                                                                                                    }
                                                                                                }
                                                                                            }>
                                                                                            <img className="avatar-img rounded-circle" src={a.patient.profileImage == '' ? 'assets/img/patients/patient.jpg' : a.patient.profileImage} alt="User Image" />
                                                                                        </Link>
                                                                                        <Link to={
                                                                                            {
                                                                                                pathname: '/PatientProfile',
                                                                                                state: {
                                                                                                    patientId: a.patient.patientId
                                                                                                }
                                                                                            }
                                                                                        }>{a.patient.firstName} {a.patient.lastName}</Link>


                                                                                        {/* <a href="patient-profile.html" className="avatar avatar-sm mr-2"><img className="avatar-img rounded-circle" src={a.patient.profileImage == '' ? 'assets/img/patients/patient.jpg' : a.patient.profileImage} alt="User Image" /></a> */}
                                                                                        {/* <a href="/patientProfile">{a.patient.firstName} {a.patient.lastName} <span>#{a.patient.patientNumber}</span></a> */}
                                                                                    </h2>
                                                                                </td>
                                                                                <td>{Util.getFormatDate({ date: a.appoinmentDate })} <span className="d-block text-info">{a.appoinmentTime}</span></td>
                                                                                <td>{a.purpose}</td>
                                                                                <td>New Patient</td>
                                                                                <td className="text-center">{a.totalAmount}</td>
                                                                                <td className="text-right">
                                                                                    <div className="table-action">
                                                                                        <a href="javascript:void(0);" className="btn btn-sm bg-info-light">
                                                                                            <i className="far fa-eye"></i> View
                                                                                            </a>

                                                                                        <a href="javascript:void(0);" style={{ display: "none" }} className="btn btn-sm bg-success-light">
                                                                                            <i className="fas fa-check"></i> Accept
                                                                                            </a>
                                                                                        <a href="javascript:void(0);" style={{ display: "none" }} className="btn btn-sm bg-danger-light">
                                                                                            <i className="fas fa-times"></i> Cancel
                                                                                            </a>
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        ))
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="tab-pane" id="today-appointments">
                                                <div className="card card-table mb-0">
                                                    <div className="card-body">
                                                        <div className="table-responsive">
                                                            <table className="table table-hover table-center mb-0">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Patient Name</th>
                                                                        <th>Appt Date</th>
                                                                        <th>Purpose</th>
                                                                        <th>Type</th>
                                                                        <th className="text-center">Paid Amount</th>
                                                                        <th></th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        todayAppoinments.map(a => (
                                                                            <tr key={a.appoinmentId}>
                                                                                <td>
                                                                                    <h2 className="table-avatar">
                                                                                        <a href="patient-profile.html" className="avatar avatar-sm mr-2"><img className="avatar-img rounded-circle" src="assets/img/patients/patient.jpg" alt="User Image" /></a>
                                                                                        <a href="patient-profile.html">{a.patient.firstName} {a.patient.lastName} <span>#{a.patient.patientNumber}</span></a>
                                                                                    </h2>
                                                                                </td>
                                                                                <td>{Util.getFormatDate({ date: a.appoinmentDate })} <span className="d-block text-info">{a.appoinmentTime}</span></td>
                                                                                <td>General</td>
                                                                                <td>New Patient</td>
                                                                                <td className="text-center">{a.totalAmount}</td>
                                                                                <td className="text-right">
                                                                                    <div className="table-action">
                                                                                        <a href="javascript:void(0);" className="btn btn-sm bg-info-light">
                                                                                            <i className="far fa-eye"></i> View
                                                                                            </a>

                                                                                        <a href="javascript:void(0);" style={{ display: "none" }} className="btn btn-sm bg-success-light">
                                                                                            <i className="fas fa-check"></i> Accept
                                                                                            </a>
                                                                                        <a href="javascript:void(0);" style={{ display: "none" }} className="btn btn-sm bg-danger-light">
                                                                                            <i className="fas fa-times"></i> Cancel
                                                                                            </a>
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        ))
                                                                    }
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    );
};

export default DoctorDashboard;